<template>
    <!-- 巡检员报表 -->
  <div>
    <div class="search_wrap">
      <el-form
        :model="queryParam"
        ref="form"
        label-width="80px"
        :inline="true"
        size="mini"
      >
        <el-form-item label="巡检员">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.userName"
            placeholder="请输入"
          ></el-input>
        </el-form-item>

        <div class="selectBox">
          <span class="selectText">巡检日期</span>
          <el-date-picker
            size="mini"
            v-model="inspectionDate"
            @change="dateChange"
            :default-value="dateDefaultShow"
            unlink-panels
            :clearable="false"
            :picker-options="expireTimeOption"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>

        <el-form-item>
          <el-button type="primary" @click="searchQuery">查询</el-button>
          <el-button type="default" @click="searchReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- <downloadExcel
      class="export-excel-wrapper"
      :data="dataSource"
      :fields="json_fields"
      :header="title"
      name="巡检员报表.xls">
      <el-button type="success">导出</el-button>
    </downloadExcel> -->
    <e-table
      :listLoading="loading"
      :selection="true"
      :tableHeadConfig="columns"
      @pageChange="loadData"
      :paginationData="ipagination"
      :tableLoadData="dataSource"
      @selectLine="onSelectChange"
      :tableRowClassName="tableRowClassName"
    >
      <!-- <template #handlerSlot="slotData">
        <el-button
          size="mini"
          type="primary"
          @click="getInfo(slotData.data.row)">详情</el-button>
      </template> -->
    </e-table>
  </div>
</template>

<script>
// import downloadExcel from 'vue-json-excel'
import eTable from "@/components/table";
import { listMixin } from "@/mixins/listMixin";
import { httpAction } from "@/api/manage";
export default {
  // components: {eTable, downloadExcel},
  components: {eTable},
  mixins: [listMixin],
  data () {
    return {
      queryParam: {},
      inspectionDate: "",
      dateDefaultShow: "",
      expireTimeOption: {
        disabledDate(date) {
          return date.getTime() >= Date.now();
        },
      },
      url: {
        list: '/inspectionStatistics/inspectionUserStatistics'
      },
      columns: [
        { field: "userName", label: "巡检员" },
        // { field: "inspectionUserPhone", label: "手机号" },
        { field: "inspectionDate", label: "巡检统计日期" },
        { field: "needInspectionNum", label: "应检次数" },
        { field: "inspectionNum", label: "实检次数" },
        // { field: "onDutyNum", label: "在岗次数",},
        { field: "notOnDutyNum", label: "不在岗次数",},
        { field: "onDutyRate", label: "在岗率" },
        { field: "dutyPunishmentAmount", label: "不在岗总罚金",},
        // { field: "onTidyNum", label: "整洁次数" },
        { field: "notOnTidyNum", label: "不整洁次数" },
        { field: "onTidyRate", label: "整洁率" },
        { field: "tidyPunishmentAmount", label: "不整洁总罚金" },
        { field: "notIsPureNum", label: "不纯净次数" },
        { field: "isPureRate", label: "纯净率" },
        { field: "purePunishmentAmount", label: "不纯净总罚金" },
        { field: "punishmentNum", label: "处罚次数" },
        { field: "punishmentRate", label: "处罚率" },
        { field: "punishmentAmount", label: "处罚总金额" },
        // {
        //   width: 200,
        //   label: "信息",
        //   slotName: "handlerSlot",
        //   columnType: "slot",
        // },
      ],
      // excel属性
      title: '巡检员报表',
      json_fields: {
        "巡检员": "userName",
        // "手机号": "inspectionUserPhone",
        "巡检统计日期": "inspectionDate",
        "应检次数": "needInspectionNum",
        "实检次数": "inspectionNum",
        "在岗次数": "onDutyNum",
        "不在岗次数": "notOnDutyNum",
        "在岗率": "onDutyRate",
        "整洁次数": "onTidyNum",
        "不整洁次数": "notOnTidyNum",
        "整洁率": "onTidyRate",
        "处罚次数": "punishmentNum",
        "处罚率": "punishmentRate",
        "处罚总金额": "punishmentAmount",
        }
    }
  },
  mounted() {
    this.dateDefaultShow = new Date();
    this.dateDefaultShow.setMonth(new Date().getMonth() - 1);
  },
  updated () {
    this.dataSource.forEach(item => {
      let itemDate = item.inspectionDate.split(' ')
      item.inspectionDate = itemDate[0]
    });
  },
  methods: {
    dateChange(date) {
      this.queryParam.inspectionDateStart = date[0] + " 00:00:00";
      this.queryParam.inspectionDateEnd = date[1] + " 23:59:59";
    },
    searchReset () {
      this.queryParam = {}
      this.inspectionDate = ''
      this.searchQuery()
    },
    // getInfo (val) {
    //   console.log(val);
    // },
  }
}
</script>

<style scoped lang="scss">
  .search_wrap {
    margin: 10px 0;
  }
.selectBox {
  margin-bottom: 18px;
  display: inline-block;
  margin-right: 10px;
  vertical-align: top;
}
.selectText {
  width: 80px;
  line-height: 28px;
  font-weight: 700;
  cursor: default;
  float: none;
  display: inline-block;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  padding: 0 12px 0 0;
  box-sizing: border-box;
}

  .imgBox {
    width: 150;
    height: 150px;
    border: 1px solid rgb(223, 212, 212);
  }
</style>